document.addEventListener('variant:change', function(event) {
    const saleTextElements = document.querySelectorAll('.onsale-text');
    
    saleTextElements.forEach(function(element) {
        if (element.textContent.includes("15%")) {
            element.textContent = "המע״מ עלינו!";
        }
    });
});


document.addEventListener('variant:change', function(event) {
  if (!event.detail || !event.detail.variant) return;
  const Selectvariant = event.detail.variant;
  // Get the selected variant SKU
  const selectedVariantSKU = Selectvariant.sku;

  // Get a reference to the input field
  const subitemslistInput = document.getElementById("subitemslist");

  // Set the value of the input field to the selected variant SKU
  if (subitemslistInput) {
    subitemslistInput.value = selectedVariantSKU;
  }
          // Check if the variant price is over 2900
            const priceSplit = document.querySelector('.price-split');
            if (priceSplit) {
              if (Selectvariant.price < 290000) {
                priceSplit.classList.add('hidden');
              } else {
                priceSplit.classList.remove('hidden');
              }
            }
      });

function updatePreorderMessage() {
  // Find the checked input within .variant-picker__option-values
  var selectedVar = document.querySelector('.variant-picker__option-values input:checked');
  var singleVar = document.querySelector('#single-preorder');

  // Find the container where the preorder message will be inserted
  var preorderContainer = document.getElementById('preorder-container'); // Ensure this container exists in your HTML

  if (!preorderContainer) return;

  // Clear the existing preorder message, if any
  preorderContainer.innerHTML = '';

  // Find the input element where we want to set or clear the value
  var preorderInput = document.getElementById('preoderproperty'); // Assuming the id is 'preoderproperty' as given

  var deliveryBadge = document.getElementById('delivery-badge'); 

  // Initialize variable for preorder value
  var preorderValue = '';

  // Check if selectedVar exists and has a preorder attribute
  if (selectedVar && selectedVar.getAttribute('preorder') && selectedVar.getAttribute('preorder') !== '//0') {
    preorderValue = selectedVar.getAttribute('preorder');
  } else if (singleVar && singleVar.getAttribute('preorder') && singleVar.getAttribute('preorder') !== '//0') {
    // If selectedVar not exist or has no preorder attribute, take the attribute from singleVar
    preorderValue = singleVar.getAttribute('preorder');
  }

  // Check if preorderValue is not blank
  if (preorderValue) {
    // Create the preorder message div
    var preorderDiv = document.createElement('div');
    preorderDiv.id = 'preorder';
    preorderDiv.className = 'preorder-msg';
    preorderDiv.innerHTML = 'ניתן להזמין מוצר זה בהזמנה מראש. תאריך אספקה משוער <span id="preorder_date">' + preorderValue + '</span>';

    // Append the new preorder message to the container
    preorderContainer.appendChild(preorderDiv);

    // Update preorderInput value with preorderValue
    if (preorderInput) {
      preorderInput.value = preorderValue;
    }

    // Hide the delivery badge
    if (deliveryBadge) {
      deliveryBadge.style.display = 'none';
    }
  } else {
    // Clear preorderInput value if preorderValue is blank or no valid preorder attribute is found
    if (preorderInput) {
      preorderInput.value = '';
    }

    // Show the delivery badge
    if (deliveryBadge) {
      deliveryBadge.style.display = 'block';
    }
  }
}


// Call updatePreorderMessage on page load
document.addEventListener('DOMContentLoaded', function() {
  updatePreorderMessage();
});

// Listen for variant changes and call updatePreorderMessage accordingly
document.addEventListener('variant:change', function(event) {
  updatePreorderMessage();
});




document.addEventListener('cart:change', function(event) {
  // Get a reference to the div element
  const estDiv = document.getElementById("est");
  const shippingInput = document.getElementById("shipping");

  if (estDiv && shippingInput) {
    shippingInput.value = estDiv.textContent;
  }

  let cart = event.detail && event.detail.cart; // Get the updated content of the cart
});

// Check if the element with ID "checkout" exists
if (document.getElementById("checkout")) {
  // Get a reference to the checkout button
  const checkoutButton = document.getElementById("checkout");

  // Add a click event listener to the checkout button
  checkoutButton.addEventListener("click", function() {
    // Get a reference to the div element
    const estDiv = document.getElementById("est");

    // Get the text content of the div
    const estText = estDiv.textContent;

    // Get a reference to the input field
    const shippingInput = document.getElementById("shipping");

    // Set the value of the input field to the extracted text
    shippingInput.value = estText;
  });
}

window.addEventListener('load', function() {
  const button = document.querySelector("#bundle_addtocart_api .button");
  const buttontext = document.querySelector("#bundle_addtocart_api .button div div");
  if (!button || !buttontext) return;
  const originalText = button.textContent;
  const newText = "מוסיף לסל...";

  button.addEventListener("click", function() {
    buttontext.textContent = newText;

    setTimeout(function() {
      buttontext.textContent = originalText;
    }, 3000);
  });
});

        // Add a click event listener to the element with id "show_video"
        var showVideoEl = document.getElementById('show_video');
        if (showVideoEl) {
          showVideoEl.addEventListener('click', function () {
              // Select the first element with class "video-dot" and trigger a click
              var video = document.querySelector('video');
              var firstVideoDot = document.querySelector('.video-dot');
              if (firstVideoDot && video) {
                  video.currentTime = 0;
                  firstVideoDot.click();
              }
          });
        }